





import {Vue, Component, Prop} from 'vue-property-decorator';
import {IMAGE_POSITION, IMAGE_POSITION_ORDERED} from '@/common';
@Component({
    components: {
    },
})
export default class ImagePositionSelector extends Vue {
    @Prop({default: false})
    public disabled!: boolean;

    @Prop({default: IMAGE_POSITION.CC})
    public value!: string;

    @Prop({default: 20})
    public size!: number;

    public get positions() {
        return IMAGE_POSITION_ORDERED;
    }

    public nothing() {}
}
